import { configureStore } from '@reduxjs/toolkit'
import { createRouterMiddleware, createRouterReducer } from '@lagunovsky/redux-react-router'
import { createBrowserHistory } from 'history';

// Import reducers
import authReducer from './reducers/auth';
import userReducer from './reducers/user';
import messageReducer from './reducers/message';
import userListReducer from './reducers/userList';
import filesReducer from './reducers/files';

export const history = createBrowserHistory();

// Build the middleware for intercepting and dispatching navigation actions
const routerMiddleware = createRouterMiddleware(history);

// JWT middleware (if needed for token refresh logic)
export const jwtMiddleware = (store) => (next) => (action) => {
  return next(action);
};

// Configure store with Redux Toolkit
export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    message: messageReducer,
    userList: userListReducer,
    files: filesReducer,
    router: createRouterReducer(history),
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Redux Toolkit's default middleware includes redux-thunk
      serializableCheck: {
        // Ignore router actions for serializability check
        ignoredActions: ['@@router/LOCATION_CHANGE'],
      },
    }).concat(routerMiddleware, jwtMiddleware),
  devTools: import.meta.env.VITE_ENVIRONMENT !== 'production',
});

// Export types for TypeScript support (optional, can be used if migrating to TS later)
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
